module.exports = __webpack_public_path__ + "static/media/8_shape_r.0467f77a.webp";